import React, { useEffect, useState, useRef } from "react";
import DataTable from "react-data-table-component";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { formatNumberWithCommasAndDecimal } from "../../helper";
import style from "./payout.module.scss";
//import Filter from './filter';
import moment from "moment";
import DatePickers from "../common/DateRangePicker";
import ReactToPrint from "react-to-print";
import PurchaseReportPrintView from "./PurchaseReportPrintView";

function PendingTable(props) {
  console.log("pendingtabledata=====", props);
  const { currentTheme } = useSelector((state) => state.Theme);

  const { t } = useTranslation();
  const Currency = useSelector((state) => state.curr);
  const componentRef = useRef();
  const [date, SetDate] = useState({
    start: moment().startOf("month").format("YYYY-MM-DD"),
    end: moment().format("YYYY-MM-DD"),
    selectedValues: [],
  });
  const columns = [
    {
      name: t("payout.requestedDate"),
      selector: (row) => row.requested_date,
    },
    {
      name: "Reference Number",
      selector: (row) => row.reference_number,
    },
    {
      name: "Amount",
      selector: (row) => row.amount,
      cell: (row) => (
        <span>
          {Currency.currentCurr}{" "}
          {formatNumberWithCommasAndDecimal(
            row.amount * Currency.value,
            Currency.precision
          )}
        </span>
      ),
    },
    {
      name: "Processing Fee",
      selector: (row) => row.processingFee,
      cell: (row) => (
        <span>
          {Currency.currentCurr}{" "}
          {formatNumberWithCommasAndDecimal(
            row.processingFee * Currency.value,
            Currency.precision
          )}
        </span>
      ),
    },

    {
      name: "W/Tax",
      selector: (row) => row.tax,
      cell: (row) => (
        <span>
          {Currency.currentCurr}{" "}
          {formatNumberWithCommasAndDecimal(
            row.tax * Currency.value,
            Currency.precision
          )}
        </span>
      ),
    },
    {
      name: "Net amount",
      selector: (row) => row.amount,

      cell: (row) => (
        <span
          className={`${
            currentTheme == "theme-dark"
              ? `${style.dark_mode_credit} ${style.badge}`
              : `${style.credit} ${style.badge}`
          }`}
        >
          {Currency.currentCurr}
          {""}
          {formatNumberWithCommasAndDecimal(
            row.net_amount * Currency.value,
            Currency.precision
          )}
        </span>
      ),
    },

    {
      name: "type",
      selector: (row) => row.type,
    },
    {
      name: "Release Method",
      selector: (row) => t(`payout.${row.release_method}`),
    },

    {
      name: "status",
      selector: (row) => row.status,
      cell: (row) => (
        <div
          style={{
            color:
              row.status === "Pending"
                ? "red"
                : row.status === "paid"
                ? "green"
                : "black",
          }}
        >
          {row.status}
        </div>
      ),
    },
    {
      name: "released date",
      // selector: (row) => row.released_date,
      cell: (row) => {
        if (row.released_date == "") {
          return <span> </span>;
        }

        const adjustedTimestamp = moment
          .utc(row.released_date)
          .subtract(8, "hours");
        const formattedDate = adjustedTimestamp
          .tz("Asia/Manila")
          .format("MM/DD/YYYY h:mm:ss A");

        return <span>{formattedDate}</span>;
      },
    },
  ];

  //check box selection
  const selectedRowChange = (row) => {
    let selectedRows = row.selectedRows.map((items) => {
      return items.request_id;
    });
    props.cancelPopupHandler(selectedRows, false);
  };

  //cancel popup model
  const cancelPopup = () => {
    props.cancelPopupHandler([], true);
  };
  //onchange page
  const handlePageChange = (inPage) => {
    props.paginationchange(inPage, props.ContentData.perPage);
  };
  const handlePerRowsChange = (perPage, inPage) => {
    props.paginationchange(inPage, perPage);
  };
  const handleOnSort = ({ selector }, sortDirection) => {
    props.paginationchange(
      props.ContentData.inPage,
      props.ContentData.perPage,
      selector,
      sortDirection
    );
  };
  return (
    <div>
      <div>
        <DatePickers {...props.filter} change={props.changeDate} />
        <Button
          style={{ marginLeft: "10px" }}
          className={`${style.btnPrimary}`}
          onClick={props.submitFilter}
        >
          {t("Button.search")}
        </Button>
        <Button
          style={{ marginLeft: "10px" }}
          className={`${style.btnInfo}`}
          onClick={props.resetButton}
        >
          {t("Button.reset")}
        </Button>

        <span style={{ float: "right" }} className={style.exportButton}>
          <Button
            style={{ margin: "10px" }}
            onClick={() => {
              props.exportdata("excel");
            }}
          >
            <i className="fa fa-file-excel-o"></i>
            {t("Button.excel")}
          </Button>
          <Button
            style={{ margin: "10px" }}
            onClick={() => {
              props.exportdata("csv");
            }}
          >
            <i className="fa fa-file-text-o"></i>
            {t("Button.CSV")}
          </Button>
          <ReactToPrint
            //trigger={() => <Button><i className="fa fa-print"></i>{t('Button.print')}</Button>}
            trigger={() => (
              <Button style={{ margin: "10px" }}>
                <i class="fa fa-print"></i>
                {t("Button.print")}
              </Button>
            )}
            content={() => componentRef.current}
          />
        </span>
        <div style={{ display: "none" }}>
          <PurchaseReportPrintView
            ref={componentRef}
            filter={props.changeDate}
            {...props}
          />
        </div>
      </div>

      <DataTable
        columns={columns}
        data={props.ContentData}
        highlightOnHover
        progressPending={props.pending}
        progressComponent={<div>Loading</div>}
        persistTableHead
        noHeader
        pagination
        paginationServer
        responsive
        paginationTotalRows={props.totalRows}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        noDataComponent={t("Common.noDataRecordsToDisplay")}
      />
      {/* { 
          props.ContentData.selectedRows.length > 0 &&
          <div className={style.popupButtonArea}>
              <ul>
                <li>
                  <span onClick={cancelPopup}>
                    <i className="fa fa-times"></i>
                  </span>
                </li>
                <li>
                  <span className={style.CountRound}>
                  {props.ContentData.selectedRows.length}
                  </span>
                  <span className={style.spanText}>
                  {t('payout.itemsSelected')}
                  </span>
                </li>
                <li>
                  <Button variant="danger" className={style.CancelButton} onClick={props.onSubmit}>
                    <i className="fa fa-trash-o"></i>
                    {t('Button.cancel')}
                  </Button>
                </li>
              </ul>
          </div>
        } */}
    </div>
  );
}

export default PendingTable;
